import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Text = styled.h2` {
  ${({ theme }) => theme.typograph.titleRegular}
  margin-bottom: 2px;
}
`;

const Info = styled.p` {
  ${({ theme }) => theme.typograph.paragraphRegular}
  margin-bottom: 24px;
}
`;

const TextAndInfo = ({ text, info }) => (
  <>
    <div>
      <Text>{text}</Text>
      <Info>{info}</Info>
    </div>
  </>
);

TextAndInfo.propTypes = {
  text: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
};

export default TextAndInfo;
